/**
 * Created by asiulik on 15.11.2017.
 */
define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../utils', './subheader'],
    function($, _, EventEmitter, Utils, Subheader) {

        var config = {

            OPEN_NAV_SELECTOR: "#headerMobileOpen",
            CLOSE_NAV_SELECTOR: "#headerMobileClose",
            HEADER_MOBILE_SELECTOR: "#headerMobile",
            FAV_ITEM_SELECTOR: "[data-fav-element]",
            OVERLAY_CLASS: '.overlay',
            ANIMATE_VALUE_CLASS: "p__header__icon--animate",
            MOBILE_ITEM_SELECTOR: '.header__mobile__item'

        };

        function Header(overlayInstance, layoutInstance){

            this.overlayInstance = overlayInstance;
            this.layoutInstance = layoutInstance;

            this.initSubheader();

        }

        Header.prototype = _.clone(EventEmitter.prototype);

        Header.prototype.init = function(){

            var _this = this;

            this.$headerMobile = $(config.HEADER_MOBILE_SELECTOR);
            this.$overlay = this.$headerMobile.closest(config.OVERLAY_CLASS);

            this.$openMobileNavBtn = $(config.OPEN_NAV_SELECTOR);
            this.$closeModileNavBtn = $(config.CLOSE_NAV_SELECTOR);

            this.$favElement = $(config.FAV_ITEM_SELECTOR);

            this.$mobileHeaderItems = $(config.MOBILE_ITEM_SELECTOR);

            this.bindEvents();
        };

        Header.prototype.initSubheader = function(){

            this.subheader = new Subheader();
            this.subheader.init();

        };

        Header.prototype.bindEvents = function(){

            var _this = this;

            this.$openMobileNavBtn.on({
                click: function(e){
                    _this.mobileHeaderOpened ? (function(){

                            _this.overlayInstance.hideOverlay();
                            _this.mobileHeaderOpened = false;

                        })() : (function(){

                            _this.overlayInstance.openOverlay(_this.$overlay);
                            _this.mobileHeaderOpened = true;

                        })();

                }
            });

            this.$closeModileNavBtn.on({
                click: function(e) {

                }
            });

            this.layoutInstance.on('reload', function(){
                if(!_this.layoutInstance.mediumAndDown){
                    _this.overlayInstance.hideOverlayOnCondition(_this.$overlay);
                }

            });

            this.$mobileHeaderItems.on({
                click: function(){
                    _this.overlayInstance.hideOverlay();
                }
            });

            this.$favElement.closest('.p__header__icon').on({
                mouseover: function(){
                    _this.emit('header:favMouseOver');
                },
                mouseout: function(){
                    _this.emit('header:favMouseOut');
                }
            });


        };

        Header.prototype.updateFavValue = function($element, $container, value){

            // console.log($element, $container, value);

            var elementValue = parseInt($element.text());

            var newElementValue = value ? value : elementValue + 1;

            $element.html(newElementValue);
            $container.addClass(config.ANIMATE_VALUE_CLASS);
            if (value > 0) {
              $container.find('svg > path').css('fill','black')
            } else {
              $container.find('svg > path').css('fill','none')
            }

            setTimeout(function(){
                $container.removeClass(config.ANIMATE_VALUE_CLASS);
            }, 700);

        };

        Header.prototype.destroy = function(){

        };

        return Header;

    }

);



// WEBPACK FOOTER //
// ./Private/Scripts/modules/header/header.js